import { render, staticRenderFns } from "./LockAssessments.vue?vue&type=template&id=1efe219f"
import script from "./LockAssessments.vue?vue&type=script&lang=js"
export * from "./LockAssessments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports